import React from 'react'

const CLASS_STICKY_NODE = 'sticky-bar'
const CLASS_STICKY_NODE_CONTAINER = `${CLASS_STICKY_NODE}-container`
const CLASS_VISIBLE = `${CLASS_STICKY_NODE}--visible`

class StickyBar extends React.Component {
    constructor(props) {
        super(props)
        this.bar = React.createRef()
        this.barContainer = React.createRef()
    }

    componentDidMount() {
        const stickyBar = this.bar.current
        const stickyBarContainer = this.barContainer.current

        const sticky = () => {
            const showBar =
                stickyBarContainer.getBoundingClientRect().top <
                stickyBar.getBoundingClientRect().height
            if (showBar) {
                stickyBar.classList.add(CLASS_VISIBLE)
            } else {
                stickyBar.classList.remove(CLASS_VISIBLE)
            }
        }

        window.addEventListener('resize', sticky)
        window.addEventListener('scroll', sticky)

        sticky()
    }

    render() {
        const { title } = this.props
        return (
            <div
                className={CLASS_STICKY_NODE_CONTAINER}
                ref={this.barContainer}
            >
                <div className={CLASS_STICKY_NODE} ref={this.bar}>
                    <div className="sticky-bar__inner">
                        <div className="sticky-bar__title">{title}</div>
                    </div>
                </div>
            </div>
        )
    }
}

export default StickyBar



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/StickyBar.jsx